import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextArea } from "../components/common/TextArea";
import { TextBox } from "../components/common/TextBox";
import PopupContent from "../components/popupContent";

import PopupOperationsBar from "./PopupOperationsBar";
import iconReceptury from "../images/buttons/receptura.png";
import { addNotification } from "../redux/actions";
import { apiGetAllProducts } from "../services/ProductsService";
import { SelectBox } from "../components/common/SelectBox";
import { apiCreateOrUpdateBasis, apiGetAllBasesByProduct, apiGetBasesDetail } from "../services/BasesService";
import { NumericBox } from "../components/common/NumericBox";
import ComboBoxData from "../components/common/ComboBoxData";
import { apiGetAllSampleCards, apiGetSampleCardsForProduct } from "../services/SampleCardsService";
import { apiGetAllColorsForSampleCard } from "../services/ColorsService";
import DataGrid from "../components/common/DataGrid";
import ReceiptPopupPigments from "./ReceiptPopupPigments";
import { apiReceiptCreateOrUpdate } from "../services/ReceiptsService";
import { apiGetAllPigments } from "../services/PigmentsService";
import { checkCrud } from "../helpers/userRolesHelper";
import { apiGetAllSellers } from "../services/SellersService";
// styles
require("./PopupGeneralStyles.css");
require('./ReceiptPopup.css');

interface Props {
  id?: number;
  handleCancel: any;
  refreshData: any;
  receiptDetail?: any;
  productPrefersLitres: any;
  isCustom: any
}

interface SelectedValuesState {
  sampleCardId: string;
  colorId: string;
  sellerId?: any;
  basisId: string;
  colors: any[];
  sellers: any[];
  basis: any[];
  sampleCards: any[];
  pigmentsRatio: any;
  customAmount: number;
}

const ReceiptPopup = (props: Props) => {

  const [loading, setLoading] = useState(true);
  const data: any = {};

  if (props.receiptDetail) {
    data.noteInternal = props.receiptDetail.noteInternal;
    data.noteExternal = props.receiptDetail.noteExternal;
  }

  const [formData, setFormData] = useState(data);
  const [saveError, setSaveError] = useState(false);

  const [receiptDetail, setReceiptDetail] = useState(props.receiptDetail || {});

  const [pigmentPopup, setPigmentsPopup] = useState({ 'visible': false, 'idPigment': null, 'allPigments': [], baseAmount: props.receiptDetail?.customAmount || 1000 });
debugger
  let initState: SelectedValuesState = {
    sampleCardId: props.receiptDetail?.sampleCardId,
    colorId: props.receiptDetail?.colorId,
    basisId: props.receiptDetail?.basisId,
    sellerId: props.receiptDetail?.sellerId,
    colors: [],
    basis: [],
    sellers: [],
    sampleCards: [],
    pigmentsRatio: props.receiptDetail?.pigmentsRatio || 0,
    customAmount: props.receiptDetail?.customAmount || 1000
  };

  const [selectedValues, setSelectedValues] = useState(initState);

  const dispatch = useDispatch();
  const selectedProductInfo = useSelector((state: any) => state.productInfo);
  const [isAdmin, setIsAdmin] = useState(false);
  var userInfo = useSelector((state: any) => state.userInfo);


  const isEditMode = props.id ? true : false;

  const setRoles = () => {
    setIsAdmin(checkCrud('receipt', 'admin', userInfo));
  }

  useEffect(() => {
    setRoles();
  }, [userInfo.UserRoles])

  useEffect(() => {
    ensureAllDataForComponents(selectedProductInfo.productId);
  }, []);

  const onAddingClick = async () => {

    setLoading(true);

    let updatingObject = { ...receiptDetail };

    updatingObject.basisId = selectedValues.basisId || receiptDetail.basisId;
    updatingObject.sampleCardId = selectedValues.sampleCardId;
    updatingObject.colorId = selectedValues.colorId || receiptDetail.colorId;
    updatingObject.sellerId = selectedValues.sellerId;
    updatingObject.pigmentsRatio = selectedValues.pigmentsRatio;
    updatingObject.noteInternal = formData.noteInternal;
    updatingObject.noteExternal = formData.noteExternal;
    updatingObject.customAmount = selectedValues.customAmount;

    if (props.isCustom) {
      updatingObject.isCustom = props.isCustom;
    }

    await apiReceiptCreateOrUpdate(updatingObject);
    setLoading(false);
    dispatch(addNotification({ text: `Receptura byla úspěšně přidána.`, type: 'success' }));
    props.refreshData();

  };

  const onEditingClick = async () => {
    setLoading(true);
    debugger;
    let updatingObject = { ...receiptDetail };

    updatingObject.basisId = selectedValues.basisId;
    updatingObject.sampleCardId = selectedValues.sampleCardId;
    updatingObject.colorId = selectedValues.colorId || receiptDetail.colorId;
    updatingObject.sellerId = selectedValues.sellerId;
    updatingObject.pigmentsRatio = selectedValues.pigmentsRatio;
    updatingObject.noteInternal = formData.noteInternal;
    updatingObject.noteExternal = formData.noteExternal;
    updatingObject.customAmount = selectedValues.customAmount;

    if (props.isCustom) {
      updatingObject.isCustom = props.isCustom;
    }

    await apiReceiptCreateOrUpdate(updatingObject);

    setLoading(false);

    dispatch(addNotification({ text: `Receptura byla úspěšně upravena.`, type: 'success' }));
    props.refreshData();
  };

  const ensureAllDataForComponents = async (productId: number) => {
    var allBasisForProduct = await loadBasisForProduct(productId);
    var allSampleCardsForProduct = await loadSampleCards();
    var allSellers = (await apiGetAllSellers()).data;

    var sampleCardIdForColors = null;
    var selectedSampleCard = props.receiptDetail?.sampleCardId ?
      allSampleCardsForProduct.filter(a => a.id == props.receiptDetail?.sampleCardId) : [];

    if (selectedSampleCard.length > 0) {
      sampleCardIdForColors = selectedSampleCard[0].id;
    }
    else {
      if (allSampleCardsForProduct.length > 0) {
        sampleCardIdForColors = allSampleCardsForProduct[0].id;
      }
    }

    var allColorsForSampleCard = await loadColorsForSampleCard(sampleCardIdForColors);

    if (!props.receiptDetail) {
      setReceiptDetail({
        colorId: allColorsForSampleCard && allColorsForSampleCard.length > 0 ? allColorsForSampleCard[0].id : null,
        productId: productId,
        sampleCardId: sampleCardIdForColors,
        basisId: allBasisForProduct && allBasisForProduct.length > 0 ? allBasisForProduct[0].id : null
      })
    }

    setSelectedValues({
      ...selectedValues,
      basis: allBasisForProduct,
      sampleCards: allSampleCardsForProduct,
      colors: allColorsForSampleCard, colorId: initState.colorId,
      sellers: [{ id: 0, name: '-' }, ...allSellers]
    });


  }

  const loadSampleCards = async () => {


    let loadedSampleCards = await apiGetAllSampleCards();
    return loadedSampleCards.data;
  }

  const loadColorsForSampleCard = async (sampleCardId: any) => {

    let loadedColors = await apiGetAllColorsForSampleCard(sampleCardId);
    return loadedColors.data;

  }

  const loadBasisForProduct = async (productId: any) => {

    var loadedBasis = await apiGetAllBasesByProduct(productId);
    return loadedBasis.data;
  }

  const handleBaseChange = (id: any) => {

    setSelectedValues({ ...selectedValues, basisId: id });
  }

  const handleSampleCardChange = async (id: any) => {

    var allColorsForSampleCard = await loadColorsForSampleCard(id);

    let newState = { ...selectedValues };
    newState.sampleCardId = id;

    var colors = allColorsForSampleCard.filter(a => a.Id == selectedValues.colorId);

    if (colors.length === 0) { // we need to select first color if our preferenced one is not in the set
      setSelectedValues({ ...selectedValues, colors: allColorsForSampleCard, sampleCardId: id, colorId: allColorsForSampleCard[0].id });
    }
    else {
      setSelectedValues({ ...selectedValues, colors: allColorsForSampleCard, sampleCardId: id, colorId: colors[0].id });
    }
  }

  const handleColorChange = (id: any) => {

    setSelectedValues({ ...selectedValues, colorId: id });
  }

  const handleSellerChange = (id: any) => {

    setSelectedValues({ ...selectedValues, sellerId: id });
  }

  const handlePigmentsRationChange = (ratio: any) => {

    setSelectedValues({ ...selectedValues, pigmentsRatio: ratio });
  }

  const onCancelClick = () => {
    props.handleCancel();
  };

  let mappedPigments: any[] = [];
  let selectedPigmentAmount = 0;

  if (receiptDetail && receiptDetail.pigments && receiptDetail.pigments.length > 0) {
    receiptDetail.pigments.forEach((pigmentDetail: any) => {

      if (pigmentDetail.idPigment == pigmentPopup.idPigment) {
        selectedPigmentAmount = pigmentDetail.amount;
      }

      mappedPigments.push({
        'id': pigmentDetail.idPigment,
        'name': pigmentDetail.pigment.name,
        'density': pigmentDetail.pigment.density,
        'amountInGrams': pigmentDetail.formattedAmountInGrams,
        'amountInMililitres': pigmentDetail.formattedAmountInMililitres
      });
    });
  }

  return (
    <PopupContent
      customClassForCardBody='maxHeight770'
      headerIcon={iconReceptury}
      additionalClassNames={'ReceiptPopup'}
      header={props.id ? `Úprava receptury pro výrobek ${selectedProductInfo.productName}` :
        `Přidání receptury pro výrobek ${selectedProductInfo.productName}`}
    >
      <>
        {pigmentPopup.visible && (
          <ReceiptPopupPigments
            customAmount={pigmentPopup.baseAmount}
            allPigments={pigmentPopup.allPigments}
            idPigment={pigmentPopup.idPigment}
            idReceipt={receiptDetail?.id}
            amount={selectedPigmentAmount}
            handleConfirmation={(id, name, density, amountInGrams, amountInMililitres) => {

              let newState = { ...receiptDetail };
              if (!newState.sampleCardId) {
                newState.sampleCardId = selectedValues.sampleCardId;
              }

              if (!newState.colorId) {
                newState.colorId = selectedValues.colorId;
              }

              if (!newState.basisId) {
                newState.basisId = selectedValues.basisId;
              }


              var existingPigment = newState.pigments ? newState.pigments.filter(a => a.idPigment == id) : null;

              var amountInGramsRounded = Math.round(amountInGrams * 10000) / 10000;
              var amountInMililitresRounded = Math.round(amountInMililitres * 10000) / 10000;

              if (!existingPigment || existingPigment.length === 0) {

                if (!newState.pigments) {
                  newState.pigments = [];
                }

                newState.pigments.push({
                  idPigment: id,
                  pigment: { name: name, density: density },
                  amount: amountInGrams,
                  formattedAmountInGrams: amountInGramsRounded.toString(),
                  formattedAmountInMililitres: amountInMililitresRounded.toString()
                });
              }
              else {

                existingPigment[0].amount = amountInGrams;
                existingPigment[0].formattedAmountInGrams = amountInGramsRounded.toString();
                existingPigment[0].formattedAmountInMililitres = amountInMililitresRounded.toString();

              }

              setReceiptDetail(newState);

              setPigmentsPopup({ ...pigmentPopup, visible: false, idPigment: null });
            }}
            handleCancel={() => {

              setPigmentsPopup({ ...pigmentPopup, visible: false, idPigment: null });
            }}
            refreshData={undefined}
            productInLitres={selectedProductInfo.productPrefersLitres} />
        )}


        <ComboBoxData
          id="basis"
          label="Báze"

          dataTextField="name"
          dataValueField="id"
          value={selectedValues.basisId}
          handleChange={handleBaseChange}
          rows={selectedValues?.basis}
        />
        <ComboBoxData
          id="sampleCards"
          label="Vzorkovnice"
          dataTextField="name"
          dataValueField="id"
          value={selectedValues.sampleCardId}
          handleChange={handleSampleCardChange}
          rows={selectedValues?.sampleCards}
        />

        <ComboBoxData
          id="colors"
          label="Odstín"
          dataTextField="name"
          dataValueField="id"
          value={selectedValues.colorId}
          handleChange={handleColorChange}
          rows={selectedValues?.colors}
        />

        <ComboBoxData
          id="sellers"
          label="Prodejce"
          dataTextField="name"
          dataValueField="id"
          value={selectedValues.sellerId}
          handleChange={handleSellerChange}
          rows={selectedValues?.sellers}
        />

        <ComboBoxData
          id="pigmentsRation"
          label="Poměr pigmentů"
          dataTextField="name"
          dataValueField="id"
          value={selectedValues.pigmentsRatio || 0}
          handleChange={handlePigmentsRationChange}
          rows={[
            { 'name': '0', id: '0' },
            { 'name': '1', id: '1' },
            { 'name': '2', id: '2' },
            { 'name': '3', id: '3' },
            { 'name': '4', id: '4' },
            { 'name': '5', id: '5' }]}
        />

        <TextArea
          id="noteInternal"
          label="Poznámka:"
          placeholder="Poznámka ..."
          rows={2}
          dataField="noteInternal"
          customColClassForLabel={'col-sm-3'}
          customColClassForValue={'col-sm-9'}
          formData={formData}
          setStateMethod={setFormData}
          value={formData.noteInternal}
        />

        <TextArea
          id="noteExternal"
          label="Poznámka zákazník:"
          placeholder="Poznámka ..."
          rows={2}
          dataField="noteExternal"
          customColClassForLabel={'col-sm-3'}
          customColClassForValue={'col-sm-9'}
          formData={formData}
          setStateMethod={setFormData}
          value={formData.noteExternal}
        />

        <div className="row">
          <div className="col-sm-12" style={{ textAlign: 'right' }}>
            <a
              className="btn btn-sm btn-primary"
              onClick={async () => {
                setLoading(true);
                let allPigments = await apiGetAllPigments();
                setLoading(false);

                setPigmentsPopup({ baseAmount: selectedValues.customAmount, visible: true, idPigment: null, allPigments: allPigments.data });
                // props.setPopupData({ visible: true, id: undefined });
              }}
              style={{ backgroundColor: " #55acee;" }}
              role="button"
            >
              <i className="fas fa-plus-circle me-2"></i>
              Přidat pigment
            </a>
          </div>
        </div>

        <DataGrid
          additionalClassName="receiptPigments"
          loading={false}
          rows={mappedPigments}
          showDeleteButton={true}
          showEditButton={true}
          handleEditAction={async (id) => {
            setLoading(true);
            let allPigments = await apiGetAllPigments();
            setLoading(false);
            setPigmentsPopup({ ...pigmentPopup, visible: true, idPigment: id, allPigments: allPigments.data });
          }}
          onDeleteRow={(row) => {
            let newReceiptDetail = { ...receiptDetail };
            newReceiptDetail.pigments = newReceiptDetail.pigments.filter(a => a.idPigment != row.id);

            setReceiptDetail(newReceiptDetail);

          }}
          cols={[
            { name: "Název pigmentu", dataField: "name" },
            { name: "Množství (g)", dataField: "amountInGrams" },
            { name: "Množství (ml)", dataField: "amountInMililitres" },
            { name: "Hustota", dataField: "density" },
          ]}
        />

        <div className="row">
          <div className="col-sm-12">
            <div style={{ fontWeight: 'bold', color: 'blue', textAlign: 'center' }}>

              Tato receptura je zadávána v g na
              <input style={{ marginLeft: '10px', marginRight: '10px', width: '70px' }} type="number" id="customAmount" defaultValue={selectedValues.customAmount}
                onChange={(event) => {

                  setSelectedValues({ ...selectedValues, customAmount: event.target.valueAsNumber });
                }}
              />
              {`${!!props.productPrefersLitres ? `ml` : `g`}`}
            </div>
          </div>
        </div>

        <PopupOperationsBar
          handleAdding={onAddingClick}
          handleCancellation={onCancelClick}
          handleEditing={onEditingClick}
          id={props.id}
        />
      </>
    </PopupContent>
  );
};

export default ReceiptPopup;

